import AbstractCommand from "../../../core/application/AbstractCommand";
import SaveGameModel from "../model/SaveGameModel";
import SaveGameService from "./SaveGameService";
import FileModel from "../../../ngt/files/model/FileModel";
import ChatModel from "../../../ngt/chat/model/ChatModel";
import EmailModel from "../../../ngt/email/model/EmailModel";
import NGTScenarioPlayer from "../../../ngt/scenario/NGTScenarioPlayer";
import NGTVariableManager from "../../../ngt/base/NGTVariableManager";
import NPCModel from "../../../ngt/scenario/NPCModel";
import ProgressGameModel from "../model/ProgressGameModel";
import KeyDecisionsModel from "../../key-decisions/model/KeyDecisionsModel";

export default class SaveGameCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveGameService} saveGameService 
     * @param {SaveGameModel} saveGameModel 
     * @param {FileModel} fileModel 
     * @param {ChatModel} chatModel 
     * @param {EmailModel} emailModel
     * @param {NPCModel} npcModel 
     * @param {ProgressGameModel} progressGameModel
     * @param {NGTScenarioPlayer} scenarioPlayer 
     * @param {NGTVariableManager} variableManager 
     * @param {KeyDecisionsModel} keyDecisionsModel 
     */
    constructor(dispatcher, saveGameService, saveGameModel, fileModel, chatModel, emailModel, npcModel, progressGameModel, scenarioPlayer, variableManager, keyDecisionsModel, teaCornerModel, hubSaveGameModel, internalStakeholdersModel) {
        super(dispatcher);

        this._saveGameService = saveGameService;
        this._saveGameModel = saveGameModel;
        this._hubSaveGameModel = hubSaveGameModel;
        this._fileModel = fileModel;
        this._chatModel = chatModel;
        this._emailModel = emailModel;
        this._npcModel = npcModel;
        this._progressGameModel = progressGameModel;
        this._scenarioPlayer = scenarioPlayer;
        this._variableManager = variableManager;
        this._keyDecisionsModel = keyDecisionsModel;
        this._teaCornerModel = teaCornerModel;
        this._internalStakeholdersModel = internalStakeholdersModel;
    }

    execute(evt) {
        const data = evt.params ? evt.params.data.data : {};

        this._saveGameModel.internalStakeholders = this._internalStakeholdersModel.toObject();
        this._saveGameModel.hubSaveGame = this._hubSaveGameModel.toObject();
        this._saveGameModel.keyDecisions = this._keyDecisionsModel.toObject();
        this._saveGameModel.teaCorner = this._teaCornerModel.toObject();
        this._saveGameModel.progress = this._progressGameModel.toObject();
        this._saveGameModel.files = this._fileModel.toObject();
        this._saveGameModel.chats = this._chatModel.toObject();
        this._saveGameModel.emails = this._emailModel.toObject();
        this._saveGameModel.npcs = this._npcModel.toObject();
        this._saveGameModel.variables = this._variableManager.getState();

        const storyPlayer = this._scenarioPlayer.getStoryPlayer();
        this._saveGameModel.story = storyPlayer.save().serialize();

        this._saveGameModel.gameFinished = !!data.gameFinished;

        this._saveGameService.save();
    }
}